import { render, staticRenderFns } from "./SpuOffSale.vue?vue&type=template&id=fd5bf3a4&scoped=true"
import script from "./SpuOffSale.vue?vue&type=script&lang=js"
export * from "./SpuOffSale.vue?vue&type=script&lang=js"
import style0 from "./SpuOffSale.vue?vue&type=style&index=0&id=fd5bf3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5bf3a4",
  null
  
)

export default component.exports